import { Paper, CircularProgress } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React, { ReactElement } from "react";
import { useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import BarChart from "../../features/chart/BarChart";
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { useStyles } from "./datenvollstaendigkeitStyles";
import {
    selectMesswerteLoading, selectShowGraph, selectAktuellerWert, selectBarChartData
} from "./datenvollstaendigkeitSlice";

export default function GraphGrid(): ReactElement {

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const isUTC = useAppSelector(selectDate);
    const graphLoading = useAppSelector(selectMesswerteLoading);
    const showGraph = useAppSelector(selectShowGraph);
    const aktuellerWert = useAppSelector(selectAktuellerWert);
    const barChartData = useAppSelector(selectBarChartData);

    return (
        <React.Fragment >
            {showGraph && aktuellerWert.length != 0 ?
                <Paper className={classes.paper} >
                    <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
                        <div>
                            <Grid container>
                                <Grid container spacing={4}>
                                    <Grid item container xs={12}>
                                        <Grid item md={12}>
                                            <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                                                Messstellen Vollständigkeit
                                            </Typography>
                                            {graphLoading ? (
                                                <CircularProgress />
                                            ) : barChartData.series[0].data.length > 0 ?
                                                (BarChart(isUTC, barChartData)) :
                                                "Keine Daten zu den ausgewählten Messstellen vorhanden"
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </Paper>
                : <React.Fragment />}
        </React.Fragment>
    );
}
